import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminAccountModel } from '../models/adminAccount';

interface UserInterface {
  data: AdminAccountModel | null;
  loggedIn: boolean;
}

const initialState: UserInterface = {
  data: null,
  loggedIn: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginFailed: (state: UserInterface) => {
      state.data = null;
      state.loggedIn = true;
    },
    loginSuccess: (state: UserInterface, action: PayloadAction<AdminAccountModel>) => {
      state.data = action.payload;
      state.loggedIn = true;
    },
    logout: (state: UserInterface) => {
      localStorage.clear();
      window.location.href = '/';
      state.data = null;
      state.loggedIn = false;
    },
  },
});

export const { loginSuccess, logout, loginFailed } = authSlice.actions;
export default authSlice.reducer;
